import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getSettings = async () => {
  const {
    data: { data: settings },
  } = await axios.get('/api/settings');
  return settings;
};

export const useSettings = (queryOptions = {}) =>
  useQuery(['settings'], getSettings, { initialData: [], ...queryOptions });
